import { PRICE_SHEETS } from "../constants/action-types";

export const uploadPriceSheets = (result) => ({
    type: PRICE_SHEETS.UPLOAD.START,
    payload: { url: "/api/v3.0/vetl/price-sheets/upload", body: JSON.stringify(result) },
});

export const startPriceSheetsUploadJobPolling = (payload) => ({ type: PRICE_SHEETS.JOB.POLL.START, payload });

export const fetchPriceSheetsUploadJob = (jobId: string, pipelineId: string) => ({
    type: PRICE_SHEETS.JOB.FETCH.START,
    payload: { url: "/api/v3.0/vetl/job", body: { jobId, pipelineId } },
});

export const resetUploadJob = () => ({ type: PRICE_SHEETS.JOB.RESET });
